import { Globe2, ShieldCheck, Snowflake, Timer } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { useLang } from "../i18n";

const ICONS = [Globe2, ShieldCheck, Snowflake, Timer];

export const WhyUs = () => {
  const { t } = useLang();
  return (
    <section id="pourquoi" data-testid="why-section" className="bg-oris-cream py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead overline={t.why.overline} title={t.why.title} testId="why-title" />

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {t.why.cells.map((cell, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={cell.title} delay={i * 0.08} className={i === 0 ? "md:col-span-2" : ""}>
                <article
                  data-testid={`why-cell-${i}`}
                  className="group flex h-full flex-col justify-between border border-oris-green/12 bg-white p-8 transition-all duration-500 hover:border-oris-green/30 hover:shadow-[0_18px_50px_rgb(15,41,24,0.10)] lg:p-10"
                >
                  <div>
                    <Icon className="h-8 w-8 text-oris-green transition-colors duration-500 group-hover:text-oris-gold" strokeWidth={1.6} />
                    <h3 className="mt-6 font-serif text-2xl font-medium text-oris-ink lg:text-3xl">{cell.title}</h3>
                    <p className="mt-4 text-sm leading-relaxed text-oris-moss">{cell.text}</p>
                  </div>
                  <div className="mt-10 border-t border-oris-green/10 pt-5">
                    <span className="font-serif text-2xl font-medium italic text-oris-gold">{cell.stat}</span>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
